import { AutogenModelFactoringCompany, AutogenRowFactoringCompany } from "./autogen/AutogenModelFactoringCompany";

export class ModelFactoringCompany extends AutogenModelFactoringCompany<RowFactoringCompany> {
	constructor() {
		super(RowFactoringCompany);
	}
}

export class RowFactoringCompany extends AutogenRowFactoringCompany {
}